/**
 *
 * AddPartnerform
 *
 */
import React, { memo, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useAddPartnerSlice } from './slice/index';
import { selectAddPartner } from './slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import close from './CloseRed.svg';
import { Store } from 'storage';
import toast from 'react-hot-toast';

interface Props {}
const validationSchema = Yup.object({
  name: Yup.string()
    .min(3, 'Name must be at least 3 characters')
    .max(50, "Name can't be more than 50 characters")
    .required('Name is required'),
  dob: Yup.date()
    .max(new Date(), "DOB can't be in the future")
    .required('Date of birth is required'),
  Phone: Yup.string().required('Phone is required'),
});

const store = new Store();
const hidePartnerFormKey = 'hide-partner-form';
export const AddPartnerform = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const [closebox, handleclose] = React.useState(false);
  const { actions } = useAddPartnerSlice();
  const hidePartnerForm = store.get(hidePartnerFormKey);
  const dispatch = useDispatch();
  const { invitePartnerSuccessResponse } = useSelector(selectAddPartner);
  useEffect(() => {
    if (invitePartnerSuccessResponse) {
      toast.success('Invite sent');
      dispatch(actions.inviteMemberReset());
    }
  }, [invitePartnerSuccessResponse, dispatch, actions]);
  return (
    <Div className="p-3" isvisible={closebox || hidePartnerForm}>
      {t('')}
      {/*  {t(...messages.someThing())}  */}
      <div className="d-flex justify-content-center align-items-center position-relative">
        <TextHeading>
          Add a partner now, manage budget and achieve goals together!
        </TextHeading>
        <CloseButton
          src={close}
          alt="close-button"
          className="cursor-pointer"
          onClick={() => {
            handleclose(!closebox);
            store.set(hidePartnerFormKey, 'true');
          }}
        />
      </div>
      <div className="mt-5">
        <Formik
          initialValues={{ name: '', dob: '', Phone: '' }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            const payload = {
              name: values.name,
              dob: values.dob,
              phone_number: values.Phone,
            };
            dispatch(actions.inviteMember(payload));
            resetForm();
          }}
        >
          {({ errors, touched }) => (
            <Form>
              <div className="d-flex gap-4 align-items-center w-100">
                <div className="w-25" style={{ height: '45px' }}>
                  <div className="d-flex gap-2 align-items-center">
                    <LabelText>Name</LabelText>
                    <StyledField
                      type="text"
                      name="name"
                      placeholder="Your Full Name"
                      width="100%"
                      autoComplete="off"
                    />
                  </div>
                  <ErrorMessage name="name" component={ErrorText} />
                </div>
                <div className="w-25" style={{ height: '45px' }}>
                  <div className="d-flex gap-2 align-items-center w-100">
                    <LabelText>Dob</LabelText>
                    <StyledField
                      type="date"
                      name="dob"
                      placeholder="DD-MM-YYYY"
                      width="100%"
                    />
                  </div>
                  <ErrorMessage name="dob" component={ErrorText} />
                </div>
                <div style={{ width: '30%', height: '45px' }}>
                  <div className="d-flex gap-2 align-items-start w-100">
                    <LabelText className="w-50">Phone no.*</LabelText>
                    <StyledField
                      name="Phone"
                      type="phone"
                      width="100%"
                      autoComplete="off"
                      placeholder="+91 00000 00000"
                    />
                  </div>
                  <ErrorMessage name="Phone" component={ErrorText} />
                </div>
                <div>
                  <Button type="submit">Add as partner</Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <MandotaryText>* fields are mandatory</MandotaryText>
      </div>
    </Div>
  );
});
interface ViewProp {
  isvisible: boolean;
}
const TextHeading = styled.span`
  font-weight: 400;
  font-size: 20px;
`;

const Div = styled.div<ViewProp>`
  border: 1px solid #e4e6ec;
  border-radius: 20px;
  background-color: #ffff;
  width: 100%;
  display: ${props => (props.isvisible ? 'none' : 'block')};
`;

const CloseButton = styled.img`
  position: absolute;
  right: 0.1%;
`;
const ErrorText = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;
interface FeildProp {
  width: string;
}
const StyledField = styled(Field)<FeildProp>`
  padding: 10px;
  border: none;
  border-bottom: 1px solid #e4dfff;
  border-radius: 5px;
  font-size: 14px;
  width: ${props => props.width};
  padding: 0;
  &:focus {
    outline: none;
  }
`;

const LabelText = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

const MandotaryText = styled.span`
  font-weight: 300;
  font-size: 12px;
`;

const Button = styled.button`
  width: auto;
  background-color: #8276f4;
  color: #ffff;
  font-weight: 600;
  font-size: 12px;
  border: none;
  padding: 10px 20px;
  border-radius: 30px;
  height: 36px;
  cursor: pointer;

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;
